import { extend, override } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';
import icon from 'flarum/common/helpers/icon';
import Switch from 'flarum/common/components/Switch';
import Tooltip from 'flarum/common/components/Tooltip';
import app from 'flarum/forum/app';
import Composer from 'flarum/forum/components/Composer';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';

import config from '../common/config';
import AnonymousAvatar from './components/AnonymousAvatar';

function extendComposerInit(this: DiscussionComposer | ReplyComposer) {
  app.composer.fields!.isAnonymous = false;
}

function extendComposerHeaderItems(this: DiscussionComposer | ReplyComposer, items: ItemList<any>) {
  if (!app.forum.attribute('canAnonymous')) {
    return;
  }

  items.add(
    'anonymous',
    <Switch state={!!app.composer.fields!.isAnonymous} onchange={(value: boolean) => (app.composer.fields!.isAnonymous = value)}>
      <span className="AnonymousCheckboxLabel">
        {app.translator.trans(`${config.module.id}.forum.composerControls.anonymize`)}{' '}
        <Tooltip text={app.translator.trans(`${config.module.id}.forum.composerControls.anonymizeHelp`)}>
          {icon('fas fa-info-circle', {
            className: 'AnonymousCheckboxInfo',
          })}
        </Tooltip>
      </span>
    </Switch>,
    -10
  );
}

function extendComposerData(this: DiscussionComposer | ReplyComposer, data: any) {
  data.isAnonymous = !!app.composer.fields!.isAnonymous;
}

function extendComposerView(this: DiscussionComposer | ReplyComposer, vdom: any) {
  if (!app.composer.fields!.isAnonymous) {
    return;
  }

  if (!vdom || !Array.isArray(vdom.children)) {
    return;
  }

  // Loop through <ConfirmDocumentUnload> children
  vdom.children.forEach((vdom) => {
    if (!vdom || !Array.isArray(vdom.children)) {
      return;
    }

    // Loop through .ComposerBody children
    vdom.children.forEach((child, index) => {
      if (!child || !child.attrs || !child.attrs.className || child.attrs.className.indexOf('ComposerBody-avatar') === -1) {
        return;
      }

      vdom.children[index] = <AnonymousAvatar className="ComposerBody-avatar" />;
    });
  });
}

export default function () {
  extend(DiscussionComposer.prototype, 'oninit', extendComposerInit);
  extend(DiscussionComposer.prototype, 'headerItems', extendComposerHeaderItems);
  extend(DiscussionComposer.prototype, 'data', extendComposerData);
  extend(DiscussionComposer.prototype, 'view', extendComposerView);
  extend(ReplyComposer.prototype, 'oninit', extendComposerInit);
  extend(ReplyComposer.prototype, 'headerItems', extendComposerHeaderItems);
  extend(ReplyComposer.prototype, 'data', extendComposerData);
  extend(ReplyComposer.prototype, 'view', extendComposerView);

  // Flarum will try to focus the checkbox in ReplyComposer instead of the body. To work around this, we'll temporarily disable the field while this method runs
  override(Composer.prototype, 'focus', function (original) {
    const $anonymousCheckbox = this.$('.item-anonymous input');

    $anonymousCheckbox.prop('disabled', true);

    const returnValue = original();

    $anonymousCheckbox.prop('disabled', false);

    return returnValue;
  });
}
